import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, with later Tailwind utilities correctly overriding
 * earlier conflicting ones.
 *
 * clsx alone concatenates, so `cn('px-4', 'px-2')` would emit both and let CSS
 * source order decide — which is not the caller's intent and varies with build
 * output. twMerge resolves the conflict to the last one written, which is what
 * makes a `className` prop on a variant component actually able to override the
 * variant's own padding.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
